import(/* webpackMode: "eager" */ "C:\\Dados\\Projetos\\repositorios\\asksystemsai\\app\\vendas-mobile\\src\\app\\layout.tsx");
